const ko = {
    Server: {
        err1: '서버 오류. 잠시 후 다시 시도해주세요.',
        err2: "파라미터 오류",
        err3: "ID 와 비밀번호를 입력해주세요.",
    }
};

export default ko;